export const COLORS = [
  'var(--bg-green-20)',
  'var(--bg-pink-20)',
  'var(--bg-violet-20)',
  'var(--bg-wave-20)',
];
